import React, { useState, useEffect } from "react";
import { Grid, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@material-ui/core";
import { useStylesDark, useStylesLight } from "../../../Styles/BribesStyles";
import votBox from "../../../assets/votBox.png";
import BribesRow from "./BribesRow";

const Bribes = (props) => {
  const classesLight = useStylesLight();
  const classesDark = useStylesDark();
  const [classes, setClasses] = useState(classesLight);
  const { bribesArray = [], currentUser } = props;

  useEffect(() => {
    if (props.ctheme === "light") {
      setClasses(classesLight);
    } else {
      setClasses(classesDark);
    }
  }, [props.ctheme]);

  return (
    <>
      {bribesArray.length === 0 ? (
        <Grid container direction="row" justifyContent="center">
          <Paper className={classes.auctionCard}>
            <Grid container direction="column">
              <Grid item>
                <Typography className={classes.cardTitle} component="div">
                  <p>There are currently no incentives for this round.</p>
                  <p>Please check back later!</p>
                </Typography>
              </Grid>
              <Grid item>
                <img src={votBox} alt="votbox" className={classes.votBox}></img>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      ) : (
        <Grid container direction="row" justifyContent="center">
          <TableContainer
            component={Paper}
            className={classes.tableContainer}
            style={{ overflowX: "auto" }}
          >
            <Table aria-label="collapsible table" style={{ minWidth: "650px" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableCellNoBorder}
                    style={{
                      borderRadius: "10px 0 0 10px",
                      width: "20%",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      minWidth: "80px",
                    }}
                  >
                    Pool
                  </TableCell>
                  <TableCell
                    align="left"
                    className={classes.tableCellNoBorder}
                    style={{ width: "25%", minWidth: "70px" }}
                  >
                    Token
                  </TableCell>
                  {props.market === "yb" && (
                      <TableCell
                        align="left"
                        className={classes.tableCellNoBorder}
                        style={{ width: "12%", minWidth: "70px" }}
                      >
                        <Tooltip title="The maximum amount of tokens rewarded per veYB">
                          <span> Max Reward/veYB </span>
                        </Tooltip>
                      </TableCell>
                    )}
                  <TableCell
                    align="left"
                    className={classes.tableCellNoBorder}
                    style={{ width: "20%", minWidth: "70px" }}
                  >
                    Token Rewards
                  </TableCell>
                  <TableCell
                    align="left"
                    className={classes.tableCellNoBorder}
                    style={{ width: "17%", minWidth: "60px" }}
                  >
                    <Tooltip title="Total eligible votes">
                      <span>Votes</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    align="left"
                    className={classes.tableCellNoBorder}
                    style={{ width: "18%", minWidth: "60px" }}
                  >
                    <Tooltip
                      title={
                        props.market === "yb"
                          ? "USD value per veYB"
                          : "USD value per vote"
                      }
                    >
                      <span>
                        {props.market === "yb" ? "$/veYB" : "$/vlCVX"}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    className={classes.tableCellNoBorder}
                    style={{ borderRadius: "0 10px 10px 0", width: "8%" }}
                  />
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                <TableRow>
                  <TableCell
                    colSpan={7}
                    style={{
                      paddingBottom: "0.1em",
                      backgroundColor: "transparent",
                    }}
                  />
                </TableRow>
                {bribesArray.map((bribe, index) => (
                  <React.Fragment key={index}>
                    <BribesRow
                      bribe={bribe}
                      className={classes.row}
                      ctheme={props.ctheme}
                      userVotes={bribe.userVotes}
                      userReward={bribe.userReward}
                      currentUser={currentUser}
                    />
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        style={{
                          paddingBottom: "0.1em",
                          backgroundColor: "transparent",
                          borderBottom: "none",
                        }}
                      />
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </>
  );
};

export default Bribes;
